<template>
  <div class="visitor">
    <!-- <van-nav-bar title="待办" /> -->
    <!-- <div class="visitor-top"></div> -->
    <!-- <div class="form-bg-title">
      <div class="img"></div>
    </div> -->
    <div class="visitor-content">
      <!-- <div class="company">济南亚爱特软件有限公司</div>
      <div class="welcome">欢迎您</div> -->
    </div>
    <van-tabs
      sticky
      color="#1989fa"
      line-height="2px"
      line-width="50px"
      v-model="tabActive"
      :lazy-render="false"
      animated
      @click="handleRefreshApproval"
      swipe-threshold="5"
    >


      <van-tab title="全部"></van-tab>

      <van-tab
        title="预约"
        :badge="tabBadge.visitor > 0 ? tabBadge.visitor : ''"
      ></van-tab>
      <van-tab
        title="请假"
        :badge="tabBadge.leave > 0 ? tabBadge.leave : ''"
      ></van-tab>
      <van-tab
        title="代接送"
        :badge="tabBadge.pickup > 0 ? tabBadge.pickup : ''"
      ></van-tab>

      <van-tab
        title="销假"
        :badge="tabBadge.leaveoff > 0 ? tabBadge.leaveoff : ''"
      ></van-tab>

      <van-tab
        title="人员"
        :badge="tabBadge.personnel > 0 ? tabBadge.personnel : ''"
      ></van-tab>
      <!-- :badge="tabBadge.pickup > 0 ? tabBadge.pickup : false" -->

      <!-- <van-tab title="进出审批"><accessAudit /></van-tab> -->
    </van-tabs>

    <!-- 全部 -->
    <allApproval ref="allapproval" v-show="this.tabActive == 0" :ListData="ListData" />
    <!-- 预约  -->
    <subscribeCheck v-show="this.tabActive == 1" />
    <!-- 请假 -->
    <leaveAudit v-show="this.tabActive == 2" />
    <!-- 带接送/ -->
    <pickupAudit v-show="this.tabActive == 3" />
    <!-- 销假 -->
    <leaveOffAudit v-show="this.tabActive == 4" />
    <!-- 人员 -->
    <personnel v-show="this.tabActive == 5" @ListData="getListData" />

    <!-- 选择下一个推送的审批人 -->
    <!-- <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem"/> -->

  </div>
  <!-- </div> -->
</template>

<script>
import subscribeCheck from "../MakeAppointment/subscribeCheck";
import leaveAudit from "../LeaveCommand/leaveAudit";
import leaveOffAudit from "../LeaveCommand/leaveOffAudit";
import pickupAudit from "../PickUpStation/pickupAudit";
import accessAudit from "../Access/accessAudit";
import allApproval from "./allApproval";
import personnel from "../personnel/personnel";

export default {
  data() {
    return {
      tabBadge: {},
      ListData: [],
    };
  },
  computed: {
    tabActive: {
      get() {
        return this.$store.state.auditTabActive;
      },
      set(active) {
        // console.log(active)
        this.$store.commit("auditTab", active);
      },
    },
    // tabBadge() {
    //   return this.$store.state.approvalBadge
    // },
  },
  mounted() {
    if (this.tabActive == 0) {
      // console.log(this.$refs.appApproval)
    }
    this.tabBadge = this.$store.state.approvalBadge;
    console.log(this.$store.state.approvalBadge);
  },
  components: {
    subscribeCheck,
    // Interviewee,
    leaveAudit,
    pickupAudit,
    accessAudit,
    allApproval,
    leaveOffAudit,
    personnel,
  },
  methods: {
    getListData(data) {
      this.ListData = data;
    },
    handleRefreshApproval (index,title) {
      if (index == 0 && title == '全部') {
        this.$refs.allapproval.getList()
      }
    },
    // 添加下一位审批人
    handleSelIntervieweeItem (item) {
      console.log('item',item)
    }
  },
};
</script>

<style scoped lang="scss">
.dialog-wrap {
  padding: 20px;
}
.form-bg-title {
  padding: 0.6rem 1rem;
  height: 5.8rem;
  width: 100%;
  background: #fff;
  .img {
    background: url("../../assets/images/banner.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
  }
  .company {
    color: #fff;
    font-size: 1.125rem;
    font-weight: 400;
    margin-bottom: 0.1875rem;
  }
  .welcome {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.75rem;
  }
}
.visitor{
  padding-top:12vw ;
  position: relative;
}
::v-deep .van-sticky {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
}
</style>
